import * as zombieData from "./zombieData.json";
export class Zombie extends Phaser.Physics.Arcade.Sprite {
	// These are the run speed/animation chooser values
	minSpeed = 50;
	maxSpeed = 120;
	switchSpeed = 90;
	deathTimerMax = 30;

	damage: number;
	speed: number;
	direction: number;

	facingDir: number;
	facingDirPrev: number;

	xSpeed: number;
	ySpeed: number;

	path: Phaser.Geom.Point[];
	navNum: number;

	color: number;
	colors: string[];
	zombieSize: number;

	zombieWeight: number;
	zombieFortitude: number;

	requestNewPath: boolean;

	health = 1;
	score = 0;
	isSpawning = true;
	isDead = false;
	// A death animation timer
	deathTimer: number;
	stuckTimer: number;

	// Pain variables...
	hitstunDuration: number;
	hitstunImpulse: number;
	hitstunDirection: number;

	hitstunFlag: boolean;

	iframes = 0;

	// This is the constructer. When an individual zombie is spawned,
	// this function is run with parameters given to it from the scene
	constructor(scene: Phaser.Scene, x: number, y: number) {
		// This super refers to a JS thing, initializing said stuff for X and Y
		super(scene, x, y, "sprites", "split/DinoSprites - doux-0.png");
		this.colors = ["blue", "red", "green", "yellow"];
	}
	newSpawn(
		context: Phaser.Scene,
		zombieType: string,
		waveNum: number,
		spawnPoint: TiledObject
	): void {
		const json: { [index: string]: ZombieJSON } = zombieData;
		// Now, since up in the constructer it uses values the scene passes it,

		// we initialize out RNG starting point here, as I know how to contol these values, and not those ones
		// const x: number = Phaser.Math.RND.realInRange(50, 600);
		// const y: number = Phaser.Math.RND.realInRange(50, 600);

		// This gives the zambie its own RNG speed to run at to differentiate it
		this.speed = json[zombieType].speed;
		this.damage = json[zombieType].damage;

		// These are for sprite movement and AI pathing.
		// an actual Direction (0->2PI), and a facing direciton (Left or right), and its previous iteration
		this.direction = 0;
		this.facingDir = 0;
		this.facingDirPrev = -2;

		// The current speed in the X and Y directions, for adding to the X and Y position
		this.xSpeed = 0;
		this.ySpeed = 0;

		// Its own personal color, (color is a string in data, needs to be a number here)
		this.color = this.colors.indexOf(json[zombieType].color);

		// Its own personal size, determined by RNG
		this.zombieSize = json[zombieType].scaleMultiplier;
		this.zombieWeight = json[zombieType].stunDistanceResist;
		this.zombieFortitude = json[zombieType].stunTimeResist;

		// This sets the "Center" of the sprite to its actual center instead of the top left corner

		// The 17 here is a magic number, being the minimum pixel size to reasonably cover everything
		// This applies the personal size value to the Sprite, and the Hitbox respectivly
		this.setOrigin(0.5, 0.5);
		this.setSize(15, 15);
		this.setScale(this.zombieSize);
		this.setOffset(4,4);

		// hitpoints! they scale by a HPmulti (is used as %) per wave
		const HPmulti = 0.05;
		this.health = json[zombieType].health * Math.pow(1 + HPmulti, waveNum);
		this.score = json[zombieType].score;

		this.hitstunDuration = 0;
		this.hitstunImpulse = 0;
		this.hitstunDirection = 0;

		this.hitstunFlag = false;
		this.isDead = false;
		this.isSpawning = true;

		this.deathTimer = 0;
		this.setAlpha(0);

		this.navNum = -1;
		this.requestNewPath = true;

		this.stuckTimer = 0;

		this.setPosition(spawnPoint.x, spawnPoint.y);
	}
	newTarget(newPath: Phaser.Geom.Point[]): void {
		// Find a way to navigate towards this new target using a pathfinding algorithm

		// Output it into this.path
		// Or in this case, create a demo path to check things out...

		this.path = newPath;

		// Reset this.navNum
		this.navNum = 1;

		// This initializes the animation, so that when it gets itself a new target it doesnt break the animations
		// switch (this.color) {
		// 	case 0: {
		// 		this.anims.play("zbIdle");
		// 		break;
		// 	}
		// 	case 1: {
		// 		this.anims.play("zrIdle");
		// 		break;
		// 	}
		// 	case 2: {
		// 		this.anims.play("zgIdle");
		// 		break;
		// 	}
		// 	case 3: {
		// 		this.anims.play("zyIdle");
		// 		break;
		// 	}
		// }
	}

	AIpath(): void {
		// Alright, lets make this super simple then... we now have "this.path[navNum].x and .y to give us a target X and Y"
		// Set navNum to a negative number to disable the movement...
		if (this.path !== null && this.navNum >= 0 && this.navNum < this.path.length) {
			// We have a valid path if we make it here...
			this.stuckTimer = 0;

			const dx: number = this.path[this.navNum].x - this.x;
			const dy: number = this.path[this.navNum].y - this.y;

			// If it is probobly getting close to the player, we need to speed up the pathing...
			if (this.navNum >= this.path.length - 2) {
				this.requestNewPath = true;
			}

			// Have we gotten to/passed the goal line?
			// Ts line is annoying, thats why this is a magic number...
			if (Math.sqrt(dx * dx + dy * dy) < 2) {
				// We have gotten close enough to the goal line
				this.navNum += 1;
			} else {
				// Determine what direction we are facing using the X and Y from target
				this.direction = Math.atan2(dy, dx);

				// Since our facing direction of the sprites is Left or Right,
				// check which way is towards the goal, and set the facing direction
				if (dx > 0) {
					this.facingDir = -1;
				} else {
					this.facingDir = 1;
				}

				// Using the 0->2Pi facing direction, update our speeds to make this zombie move towards the player
				this.xSpeed = this.speed * Math.cos(this.direction);
				this.ySpeed = this.speed * Math.sin(this.direction);
			}
		} else {
			this.requestNewPath = true;
			// To show the animation part that we are idle?
			this.xSpeed = 0;
			this.ySpeed = 0;

			this.facingDir = 0;

			this.stuckTimer += 1;
			if (this.stuckTimer >= 60) {
				this.health = -1;
			}
		}
	}

	setHitstun(duration: number, force: number, dir: number, damage: number, iframeNum: number): void {
		if (this.iframes <= 0) {
			this.hitstunFlag = true;

			this.health -= damage;

			// Small randomization to add some flair...
			this.hitstunImpulse =
				(force * Phaser.Math.RND.realInRange(0.9, 1.1)) / this.zombieWeight;
			this.hitstunDuration =
			(duration * Phaser.Math.RND.realInRange(0.9, 1.1)) / this.zombieFortitude;
			this.iframes = iframeNum;
			this.hitstunDirection = dir;
		}
	}

	// This update function is called every frame for every single zombie currently spawned.
	// So This is where all the magic happens...
	update(time: number, delta: number): void {
		// iterate the Iframes...
		if (this.iframes > 0) {
			this.iframes -= 1;
		}
		// Check to see if this zombie is dead
		if (this.health <= 0) {
			// If it has died, play an animation, fade it out along with its associated death timer...

			if (this.deathTimer <= 0) {
				this.isDead = true;
			} else {
				this.deathTimer -= 2;
				this.setAlpha(this.deathTimer / this.deathTimerMax);
			}

			const current: Phaser.Animations.Animation = this.anims.currentAnim;
			// 'If the current animation isnt one of these'
			if (
				(current.key !== "zombiebluedying" &&
					current.key !== "zombiereddying" &&
					current.key !== "zombiegreendying" &&
					current.key !== "zombieyellowdying") ||
				this.hitstunFlag
			) {
				this.hitstunFlag = false;
				this.facingDirPrev = -2;
				this.anims.play(`zombie${this.colors[this.color]}dying`, undefined, 0);
			}
		} else if (this.isSpawning) {
			// lets use the deathtimer again.... See if we can do that acutally...
			if (this.deathTimer >= this.deathTimerMax) {
				this.isSpawning = false;
			} else {
				this.deathTimer += 1;
				this.setAlpha(this.deathTimer / this.deathTimerMax);
			}
		}
		// Check to see if the zombie is in a hitstun state... and if the hit killed us, dont exit the mode
		if (this.hitstunDuration > 0) {
			// If it IS, then we temporarily disable the AI and override the animations
			// And by that I mean just not run it, and then we iterate through the impulse the bullet gave us...

			this.setVelocityX(this.hitstunImpulse * Math.cos(this.hitstunDirection));
			this.setVelocityY(this.hitstunImpulse * Math.sin(this.hitstunDirection));

			if (this.health > 0) {
				this.hitstunDuration -= 1;
				if (this.hitstunDuration <= 1) {
					// console.log("derp")
					this.requestNewPath = true;
				}
			}
			// console.log(this.hitstunImpulse);
			this.hitstunImpulse *= 0.9;

			const current: Phaser.Animations.Animation = this.anims.currentAnim;

			// 'If the current animation isnt one of these'
			if (
				(this.health > 0 &&
					current.key !== "zombiebluehurt" &&
					current.key !== "zombieredhurt" &&
					current.key !== "zombiegreenhurt" &&
					current.key !== "zombieyellowhurt") ||
				this.hitstunFlag
			) {
				this.hitstunFlag = false;
				this.facingDirPrev = -2;
				this.anims.play(`zombie${this.colors[this.color]}hurt`, undefined, 0);
			}
		}
		// if it is NOT in hitstun, then we can run the other code normally
		else if(this.health > 0){
			this.hitstunFlag = false;
			// Run one iteration of the simple AI
			// when it gets complicated we can keep all that complicated math
			// outside of this update function to keep it lookin clean
			this.AIpath();

			// Take that speed in the AI, and apply it to our zombies
			// with the engine taking into consideration how long it was since the last frame
			// Theoretically, if it lags the zombies would speed up. Similar to DK64, since the delta is taken into account....
			this.setVelocityX(this.xSpeed);
			this.setVelocityY(this.ySpeed);
			// From here, this is all animation selection.
			// This if statement is so that this ONLY runs when the facing direction changes.
			// As setting the animation will reset the frames.
			if (this.facingDir !== this.facingDirPrev) {
				this.facingDirPrev = this.facingDir;

				// So if we get to this point, the zombie just turned around.
				// And so we determine what direciton it is now facing. First off,
				// we have a check to make sure the facing direction is a value we are expecting
				if (this.facingDir !== 0) {
					// Here, we know the values are valid. So we flip the sprite based on the direction.
					// > 0 means we are facing left, so we mirror the sprite. Else we do not
					if (this.facingDir > 0) {
						this.flipX = true;
					} else {
						this.flipX = false;
					}

					// Now here, we select the animation that this little guys should have
					// There are 2 animations, a Running andimation, and a walking animation.
					// So we set a threshold, here known as SwitchSpeed
					// If we are above the switch speed, we use the running animation
					if (this.speed > this.switchSpeed) {
						// This value is an animation speed multiplier
						// Here, we take that RNG speed it got, and with this equation will but it
						// between 0.8x and 1.2x depending on what value it is between the switchspeed and max
						// The closer we are to max speed, the closer we are to 1.2x.
						const animSpeed: number =
							0.8 +
							(0.4 * (this.speed - this.switchSpeed)) /
								(this.maxSpeed - this.switchSpeed);
						// And now, we choose the sprite animation set between the 4 colors, and set the animation speed
						this.anims.play(`zombie${this.colors[this.color]}run`);
						this.anims.setTimeScale(animSpeed);
					}
					// If we are not above the switch speed, we use the walking animation...
					else {
						// This is the same equation as above, just below the switchspeed. So this is also between 0.8x and 1.2x
						const animSpeed: number =
							0.8 +
							(0.4 * (this.speed - this.minSpeed)) /
								(this.switchSpeed - this.minSpeed);
						// And now, we choose the sprite animation set between the 4 colors, and set the animation speed
						// I made it a switch statement for the lulz...
						this.anims.play(`zombie${this.colors[this.color]}walk`);
						this.anims.setTimeScale(animSpeed);
					}
				}
				// If the facing direction == 0 for some reason, then we just play the proper idle animation for its color...
				else {
					this.anims.play(`zombie${this.colors[this.color]}idle`);
				}
			}
		}
	}
}
